import { SurveyJSON } from "Survey/types"

const json: SurveyJSON = {
  success: 'Færdig!',
  errors: {
    required: 'Udfyld venligst dette'
  },
  allowNewCustomer: true,
  locales: {
    dk: {
      nextButton: 'Fortsæt',
      nextButtonHint: 'tryk <b>Enter ↵</b>',
      submitButton: 'Indsend',
      textAreaHint: '<b>Shift ⇧</b> + <b>Enter ↵</b> to make a line break',
      invalidEmail: "Email adressen er ugyldig"
    }
  },
  defaultLocale: 'dk',
  items: [
    {
      type: 'custom',
      name: 'header',
      html: 'Velkommen til Revisor1 Check bank reconciliation completed test. Skriv dit svar under hvert spørgsmål. Når du er færdig, trykker du blot på ‘færdig’ knappen, og så modtager vi automatisk dine svar. God fornøjelse!',
      buttonsAlign: 'left',
      buttons: ['next']
    },
    {
      type: 'input',
      name: 'name',
      title: 'Hvad er dit navn',
      required: true,
      placeholder: 'Jens Jensen',
    },
    {
      type: 'input',
      inputType: 'email',
      name: 'email',
      title: 'Hvad er din email adresse?',
      required: true,
      placeholder: 'email@email.com',
    },

   { type: 'textarea', name: 'hvad_betyder_bankadstemning', title: 'Hvad betyder bankafstemning?', required: true },
  { type: 'textarea', name: 'hvorfor_er_bankafstemning_vigtig', title: 'Hvorfor er bankafstemning vigtig?', required: true },
  { type: 'textarea', name: 'hvor_findes_den_dato_der_skal_afstemmes_til', title: 'Hvor findes den dato der skal afstemmes til?', required: true },
  { type: 'textarea', name: 'beskriv_formaalet_med_tasken_check_bank_reconciliation_completed', title: 'Beskriv formålet med tasken “Check_bank_reconciliation_completed”.', required: true },
  { type: 'textarea', name: 'hvordan_sammenholder_du_banksaldo_i_bogfoeringen_med_den_faktiske_banksaldo', title: 'Hvordan sammenholder du banksaldo i bogføringen med den faktiske banksaldo?', required: true },
  { type: 'textarea', name: 'hvad_skal_du_goere_hvis_kunden_har_flere_bankkonti_ved_kontrol_af_ultimo_bank', title: 'Hvad skal du gøre, hvis kunden har flere bankkonti ved kontrol af ultimo bank?', required: true },
  { type: 'textarea', name: 'hvilke_typiske_arsager_kan_give_at_banken_ikke_stemmer_ultimo', title: 'Hvilke typiske årsager kan give, at banken ikke stemmer ultimo?', required: true },
  { type: 'textarea', name: 'hvordan_kontrollerer_du_manglende_primosaldo_og_hvor', title: 'Hvordan kontrollerer du manglende primosaldo, og hvor?', required: true },
  { type: 'textarea', name: 'i_hvilke_tilfaelde_er_primosaldo_ikke_noedvendig', title: 'I hvilke tilfælde er primosaldo ikke nødvendig?', required: true },
  { type: 'textarea', name: 'hvad_skal_du_goere_hvis_en_primosaldo_mangler', title: 'Hvad skal du gøre, hvis en primosaldo mangler?', required: true },
  { type: 'textarea', name: 'hvordan_kontrollerer_du_om_banktransaktioner_mangler_det_ene_ben', title: 'Hvordan kontrollerer du, om banktransaktioner mangler “det ene ben”?', required: true },
  { type: 'textarea', name: 'hvad_betyder_toggle_matches_og_hvad_leder_du_efter', title: 'Hvad betyder “Toggle Matches”, og hvad leder du efter?', required: true },
  { type: 'textarea', name: 'hvornaar_skal_karina_kontaktes_ifm_haengende_banktransaktioner', title: 'Hvornår skal Karina kontaktes ifm. hængende banktransaktioner?', required: true },
  { type: 'textarea', name: 'hvad_er_roede_linjer_i_reconciliation_vaegten_et_udtryk_for', title: 'Hvad er Røde linjer i reconciliation / “vægten” et udtryk for?', required: true },
  { type: 'textarea', name: 'hvad_er_konsekvensen_af_roede_linjer_i_reconciliation_vaegten', title: 'Hvad er konsekvensen af røde linjer i reconciliation / “vægten”?', required: true },
  { type: 'textarea', name: 'hvilke_konsekvenser_har_det_for_bankafstemning_hvis_bilagslisten_mangelliste_ikke_er_toemt', title: 'Hvilke konsekvenser har det for bankafstemning hvis bilagslisten (mangelliste) ikke er tømt?', required: true },
  { type: 'textarea', name: 'hvilke_konsekvenser_har_det_for_bankafstemning_hvis_banklisten_mangelliste_ikke_er_toemt', title: 'Hvilke konsekvenser har det for bankafstemning hvis banklisten (mangelliste) ikke er tømt?', required: true },
  { type: 'textarea', name: 'hvordan_kan_du_hurtigt_identificere_en_fejl_i_bankafstemningen_hvis_saldoen_ikke_stemmer', title: 'Hvordan kan du hurtigt identificere en fejl i bankafstemningen, hvis saldoen ikke stemmer?', required: true },
  { type: 'textarea', name: 'hvordan_haandterer_du_en_banktransaktion_der_er_dobbelt_importeret', title: 'Hvordan håndterer du en banktransaktion, der er dobbelt importeret?', required: true },
  { type: 'textarea', name: 'kundens_ene_bankkonto_har_kun_bevaegelser_frem_til_oktober_2024_skal_denne_bankkonto_medtages_i_2025', title: 'Kundens ene bankkonto har kun bevægelser frem til oktober 2024. Skal denne bankkonto medtages i 2025?', required: true },
  { type: 'textarea', name: 'hvad_er_det_grundlaeggende_princip_ved_en_bankafstemning', title: 'Hvad er det grundlæggende princip ved en bankafstemning?', required: true },
  { type: 'textarea', name: 'hvad_er_konsekvenserne_for_vores_kunde_ved_manglende_afstemning', title: 'Hvad er konsekvenserne (for vores kunde) ved manglende afstemning?', required: true },
    {
      type: 'custom',
      name: 'header',
      html: '<h3>Færdig</h3>',
      buttonsAlign: 'left',
      buttons: ['submit']
    },
  ]
}

export default json
